var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTankerCrudeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 54,
    viewBox: "0 0 100 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 35H4C1.79086 35 0 36.7909 0 39V40C0 42.2091 1.79086 44 4 44H96C98.2091 44 100 42.2091 100 40V39C100 36.7909 98.2091 35 96 35Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54C23.4183 54 27 50.4183 27 46C27 41.5817 23.4183 38 19 38C14.5817 38 11 41.5817 11 46C11 50.4183 14.5817 54 19 54Z",
    fill: "#F7931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81 54C85.4183 54 89 50.4183 89 46C89 41.5817 85.4183 38 81 38C76.5817 38 73 41.5817 73 46C73 50.4183 76.5817 54 81 54Z",
    fill: "#F7931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 2H87.0769L96 18.5V35H67V2Z",
    fill: "#29ABE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73 6H84.7692L90 21H73V6Z",
    fill: "#F7931E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57 3H12C7.58172 3 4 6.58172 4 11V25C4 29.4183 7.58172 33 12 33H57C61.4183 33 65 29.4183 65 25V11C65 6.58172 61.4183 3 57 3Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H15V3H26V0Z",
    fill: "#29ABE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTankerCrudeIcon);
export default __webpack_public_path__ + "static/media/TankerCrudeIcon.eadde1ae4c41f8561d64a563842f08d6.svg";
export { ForwardRef as ReactComponent };